export const APP_MODAL_MAX_WIDTH = "40rem";
